import Modal from "react-modal";
import { useEffect, useState } from "react";
import api from "@/components/customAxios/Axios";
Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		zIndex: 1000,
		borderRadius: "10px",

		width: "100%", // Adjust modal width for responsiveness
		maxWidth: "900px", // Max width for larger screens
		maxHeight: "90vh", // Limit height for smaller screens
	},
};

const CodeDetailsQuestions = ({
	showFollowUpQuestion,
	setShowFollowupQuestion,
	setCurrentQuestionIndex,
}: {
	showFollowUpQuestion: boolean;
	setShowFollowupQuestion: React.Dispatch<React.SetStateAction<boolean>>;
	setCurrentQuestionIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {
	const [followUpQuestions, setFollowUpQuestions] = useState<any>([]);
	const [answer, setAnswer] = useState("");

	useEffect(() => {
		const followUpQestion = JSON.parse(
			sessionStorage.getItem("followUpQuestion") || "{}"
		);

		if (followUpQestion) {
			setFollowUpQuestions(followUpQestion);
		}
	}, [showFollowUpQuestion]);

	const submitFollowUpQuestion = async () => {
		try {
			const response = await api.post("/store_followup_answer", {
				followup_question_id: followUpQuestions[0]?.id,
				candidate_answer: answer,
			});
			if (response.status === 200) {
				setAnswer("");
				if (followUpQuestions.length === 1) {
					setShowFollowupQuestion(false);
					sessionStorage.removeItem("followUpQuestion");
					setCurrentQuestionIndex((prev) => prev + 1);
					return;
				}
				const reamingFollowUpQuestion = followUpQuestions.slice(1);
				sessionStorage.setItem(
					"followUpQuestion",
					JSON.stringify(reamingFollowUpQuestion)
				);

				setFollowUpQuestions(reamingFollowUpQuestion);
			}
		} catch (error) {}
	};

	return (
		<div>
			<Modal
				isOpen={showFollowUpQuestion}
				style={customStyles}
				contentLabel="Candidate Information Modal"
			>
				<div className="space-y-4">
					<h3 className="text-base">{followUpQuestions[0]?.question_text}</h3>
					<textarea
						value={answer}
						onChange={(e) => setAnswer(e.target.value)}
						className="w-full px-4 py-2 border  border-gray-300 rounded-lg "
						placeholder="Enter your answer here..."
						rows={8}
					/>
					<button
						onClick={submitFollowUpQuestion}
						className="float-right bg-[#BDE4C3] text-[#438437] px-4 py-2 rounded-md shadow-md hover:scale-110 transition-all"
					>
						Submit
					</button>
				</div>
			</Modal>
		</div>
	);
};

export default CodeDetailsQuestions;
